import {
  CoachProfile,
  JoonColorExpanded,
  JoonUIColor,
  Typography,
  UserRole,
} from "@joonapp/web-shared"

import { TherapistProfile } from "../../types"

const CareTeamAvatar = ({
  profile,
  size = "lg",
}: {
  profile: CoachProfile | TherapistProfile
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl"
}) => {
  const imageUrl = profile.profile_image_url || ""
  const role = profile.role || ""
  const displayName = profile.nickname
    ? profile.nickname
    : `${profile.user.name} ${profile.user.last_name || ""}`

  const avatarSizeMap: Record<string, string> = {
    xxs: "16px",
    xs: "20px",
    sm: "24px",
    md: "32px",
    lg: "48px",
    xl: "80px",
  }

  const fontSizeMap: Record<string, string> = {
    xxs: "10px",
    xs: "13px",
    sm: "15px",
    md: "20px",
    lg: "32px",
    xl: "56px",
  }

  return (
    <div
      style={{
        minWidth: avatarSizeMap[size],
        maxWidth: avatarSizeMap[size],
        minHeight: avatarSizeMap[size],
        maxHeight: avatarSizeMap[size],
        borderRadius: "50%",
        background:
          role === UserRole.COACH
            ? JoonColorExpanded.yellow400
            : JoonColorExpanded.purple300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          style={{
            width: avatarSizeMap[size],
            height: avatarSizeMap[size],
            borderRadius: "50%",
            objectFit: "cover",
            objectPosition: "center",
          }}
          alt="Coach Profile"
        />
      ) : (
        <Typography
          variant="h1"
          color={JoonUIColor.text.inverted}
          style={{
            fontSize: fontSizeMap[size],
            lineHeight: avatarSizeMap[size],
          }}
        >
          {displayName[0].toUpperCase()}
        </Typography>
      )}
    </div>
  )
}

export default CareTeamAvatar
